export default __webpack_public_path__ + "static/media/0f.181ddcaf.jpg";